// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CartCheckController from "./cart_check_controller.js"
application.register("cart-check", CartCheckController)

import DoorSummaryController from "./door_summary_controller.js"
application.register("door-summary", DoorSummaryController)

import DynamicSelectController from "./dynamic_select_controller.js"
application.register("dynamic-select", DynamicSelectController)

import ElementController from "./element_controller.js"
application.register("element", ElementController)

import FormChangeController from "./form_change_controller.js"
application.register("form-change", FormChangeController)

import ImageStackController from "./image_stack_controller.js"
application.register("image-stack", ImageStackController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import RadioController from "./radio_controller.js"
application.register("radio", RadioController)

import ShowHideController from "./show_hide_controller.js"
application.register("show-hide", ShowHideController)

import SortableController from "./sortable_controller.js"
application.register("sortable", SortableController)

import SummaryController from "./summary_controller.js"
application.register("summary", SummaryController)

import ToastController from "./toast_controller.js"
application.register("toast", ToastController)

import ToggleFavoriteController from "./toggle_favorite_controller.js"
application.register("toggle-favorite", ToggleFavoriteController)

import TsSelectController from "./ts_select_controller.js"
application.register("ts-select", TsSelectController)
